import React, { Children } from 'react';
import PropTypes from 'prop-types';
import { XingFrameConsumer } from '@xingternal/xing-frame-provider';

const FENCE_TYPE_BASIC = 'basic';
const FENCE_TYPE_PREMIUM = 'premium';
const FENCE_TYPE_PROJOBS = 'projobs';
const FENCE_TYPES = [FENCE_TYPE_BASIC, FENCE_TYPE_PREMIUM, FENCE_TYPE_PROJOBS];

const Fence = ({
  user,
  min = FENCE_TYPE_BASIC,
  max = FENCE_TYPE_PROJOBS,
  rule,
  children,
}) => {
  if (!user || Object.keys(user).length === 0) {
    return null;
  }

  let currentWeight = 0;

  if (user.features.isPremium) {
    currentWeight = 1;
  }

  if (user.features.hasProJobsMembership) {
    currentWeight = 2;
  }

  const minWeight = FENCE_TYPES.indexOf(min);
  const maxWeight = FENCE_TYPES.indexOf(max);

  let isVisible = currentWeight >= minWeight && currentWeight <= maxWeight;

  // rule -> function that returns a boolean -> beats all
  isVisible = rule ? rule(user) : isVisible;

  return isVisible ? Children.only(children) : null;
};

Fence.propTypes = {
  min: PropTypes.oneOf(FENCE_TYPES),
  max: PropTypes.oneOf(FENCE_TYPES),
  rule: PropTypes.func,
  children: PropTypes.node.isRequired,
};

export { Fence, FENCE_TYPE_BASIC, FENCE_TYPE_PREMIUM, FENCE_TYPE_PROJOBS };

// eslint-disable-next-line react/display-name
export default props => (
  <XingFrameConsumer>
    {user => <Fence {...props} user={user} />}
  </XingFrameConsumer>
);
